import React, { useMemo, useCallback } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import SelectSearchField from '../../../../../general/custom-search-select/SelectSearchField';
import { NoOptionMenuList } from '../../../../../general/rules';
import { CInvalidFeedback } from '../../../../../migration/CInvalidFeedback';
import CLabel from '../../../../../migration/CLabel';

const CConditionOptions = (props) => {
    const {
        selectType,
        selectOptions = [],
        activeOption = null,
        changeAValueOfGroup,
        lvl2Group,
        lvl1GroupIndex,
        lvl2GroupIndex,
        isDisabled = false,
        error = {},
        propName,
        hiddenCondition = false,
        enrichmentType = []
    } = props;

    const ID_AND_KEY_PROP_NAME = useMemo(() => (
        propName || 'id & key'
    ), [propName]);

    const defaultSelectValue = useMemo(() => ({ label: 'Select' }), []);

    const handleConversionChange = useCallback((selectedItem) => {
        changeAValueOfGroup({
            lvl1GroupIndex,
            lvl2GroupIndex,
            propName: ID_AND_KEY_PROP_NAME,
            propValue: selectedItem?.value || null,
        });
    }, [changeAValueOfGroup, lvl1GroupIndex, lvl2GroupIndex, ID_AND_KEY_PROP_NAME]);

    const handleEnrichmentTypeChange = useCallback((value) => {
        const enrichmentType = value?.map(item => item.value).join(',') || '';
        changeAValueOfGroup({
            lvl1GroupIndex,
            lvl2GroupIndex,
            propName: 'enrichmentType',
            propValue: enrichmentType,
        });
    }, [changeAValueOfGroup, lvl1GroupIndex, lvl2GroupIndex]);


    return (
        <>
            <div className='select-event-variable mb-2'>
                <CLabel>Select a {selectType}</CLabel>
                {selectOptions.length === 0 ? (
                    <Select
                        classNamePrefix='react-select'
                        value={defaultSelectValue}
                        isSearchable={false}
                        className={`not-selected ${isDisabled ? ' disable-select' : ''}${!!error.key ? ' is-invalid custom-select-invalid' : ''}`}
                        components={{ MenuList: NoOptionMenuList }}
                        isDisabled={isDisabled}
                    />
                ) : (
                    <SelectSearchField
                        options={selectOptions}
                        value={activeOption || defaultSelectValue}
                        onChange={handleConversionChange}
                        className={`${isDisabled ? 'disable-select' : ''}`}
                        classNameWrapper={!!(error[ID_AND_KEY_PROP_NAME] || error.key) ? ' is-invalid custom-select-invalid' : ''}
                        isDisabled={isDisabled}
                        placeholder="Select..."
                    />
                )}

                <CInvalidFeedback>{error[ID_AND_KEY_PROP_NAME] || error.key}</CInvalidFeedback>
            </div>

            {!hiddenCondition && (
                <div style={{ alignSelf: 'end', marginBottom: '17px', marginLeft: '15px' }}>
                    Always applies
                </div>
            )}

            {enrichmentType?.length > 0 && (
                <div className='select-type'>
                    <CLabel>Enrichment Type</CLabel>
                    <Select
                        classNamePrefix='react-select'
                        id='enrichmentType'
                        name='enrichmentType'
                        options={enrichmentType}
                        isMulti
                        isClearable
                        closeMenuOnSelect
                        value={lvl2Group.enrichmentType ? lvl2Group.enrichmentType.split(',').map((item) => ({value: item, label: item})) : []}
                        className={error.enrichmentType ? 'is-invalid' : null}
                        onChange={handleEnrichmentTypeChange}
                    />
                    {error.enrichmentType && <CInvalidFeedback>{error.enrichmentType}</CInvalidFeedback>}
                </div>
            )}
        </>
    )
};

CConditionOptions.propTypes = {
    selectType: PropTypes.string,
    selectOptions: PropTypes.array,
    activeOption: PropTypes.object,
    changeAValueOfGroup: PropTypes.func.isRequired,
    lvl1GroupIndex: PropTypes.number.isRequired,
    lvl2GroupIndex: PropTypes.number.isRequired,
    lvl2Group: PropTypes.object.isRequired,
    isDisabled: PropTypes.bool,
    error: PropTypes.object,
    propName: PropTypes.string,
    hiddenCondition: PropTypes.bool,
    enrichmentType: PropTypes.arrayOf(PropTypes.shape({
        value: PropTypes.any.isRequired,
        label: PropTypes.string.isRequired,
    })),
};

export default React.memo(CConditionOptions);